import { Injectable } from '@angular/core';
import {
 HttpEvent,
 HttpHandler,
 HttpInterceptor,
 HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../Environment/environment.prod';
@Injectable()
export class ApimInterceptor implements HttpInterceptor {
 intercept(
   req: HttpRequest<any>,
   next: HttpHandler
 ): Observable<HttpEvent<any>> {
   const modifiedReq = req.clone({
     setHeaders: {
       'Conetools-Subscription-Key':
         environment.apimSubscriptionKey
     }
   });
   return next.handle(modifiedReq);
 }
}